<mat-table
  [dataSource]="items"
  matSort
  matSortDisableClear
  [matSortActive]="sort"
  [matSortDirection]="sortDirection"
  (matSortChange)="onSortChange($event)"
>
  <ng-container matColumnDef="serialNumber">
    <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'appliances.labels.fususCore' | t }}</mat-header-cell>
    <mat-cell *matCellDef="let item">
      <span class="fs-text-truncate">
        {{ item.serialNumber }}
      </span>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="securityProfileName">
    <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'appliances.table.profile' | t }}</mat-header-cell>
    <mat-cell *matCellDef="let item">
      <span class="fs-text-truncate">
        {{ item.securityProfileName }}
      </span>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="behavior">
    <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'appliances.table.behavior' | t }}</mat-header-cell>
    <mat-cell *matCellDef="let item">
      <span class="fs-text-truncate">
        {{ item.behavior }}
      </span>
    </mat-cell>
  </ng-container>

  <ng-container matColumnDef="eventTime">
    <mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'common.date' | t }}</mat-header-cell>
    <mat-cell *matCellDef="let item">
      <span class="fs-text-truncate">
        {{ item.eventTime | fsFormatDate : 'medium' }}
      </span>
    </mat-cell>
  </ng-container>

  <mat-header-row *matHeaderRowDef="columns"></mat-header-row>
  <mat-row
    matRipple
    [@snFadeIn]
    [@snFadeOut]
    (click)="onItemTap(item)"
    (doubletap)="onItemDblTap(item)"
    *matRowDef="let item; columns: columns"
  >
  </mat-row>
</mat-table>
